import {
    GET_ARCHIVED_CLIENTS_COUNT_PENDING,
    GET_ARCHIVED_CLIENTS_COUNT_FULFILLED, 
    GET_ARCHIVED_CLIENTS_COUNT_REJECTED,
    GET_ARCHIVED_CLIENTS_LIST_PENDING,
    GET_ARCHIVED_CLIENTS_LIST_FULFILLED, 
    GET_ARCHIVED_CLIENTS_LIST_REJECTED,
    GET_ARCHIVED_CLIENT_PENDING,
    GET_ARCHIVED_CLIENT_FULFILLED, 
    GET_ARCHIVED_CLIENT_REJECTED,
} from '../../actions/action-constants';
const initialState = {
    archivedclientEntry: [],
    clientEntry: [],
    archivedclients: [],

    alchoholaftercareprograms: [],
    bop: [],
    drugaftercareprograms: [],
    financialresponsibilityprograms: [],
    gangaffiliations: [],
    bopinstitutions: [],
    institutions: [],
    levelsofsecurity: [],
    referralsources: [],
    tblCount: 0,
    loadingList: false,

    dataEntry: {},
    dataList: [],

    errorInvalidEntry: false,
    errors: [],
};
const reducerArchivedClients = (state = initialState, action) => {
  var dataEntry;
  var dataList;
  switch (action.type) {
    /* this was added with the redux promise middleware 
    you now have to put _FULFILLED, _REJECTED, after the action name to get the response
    without this middleware you will not get these status'
    */
    case GET_ARCHIVED_CLIENT_PENDING:
    case GET_ARCHIVED_CLIENTS_COUNT_PENDING:
    case GET_ARCHIVED_CLIENTS_LIST_PENDING:
        state = {
            ...state
            , loadingList: true
        };
        break;
    case GET_ARCHIVED_CLIENTS_COUNT_FULFILLED:
        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.archivedclientscount[0].count : -1 ;
        state = {
            ...state,
            loadingList: false,
            addSuccess: false,
            updateSuccess: false,
            deleteSuccess: false,
            transferSuccess: false,
            archiveSuccess: false,
            errorInvalidEntry: false,
            tblCount: dataEntry,
        };
        break;
    case GET_ARCHIVED_CLIENTS_LIST_FULFILLED:
        dataList = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.archivedclients : [] ;
        state = {
            ...state
            , loadingList: false
            , errorInvalidEntry: false
            , dataList: dataList
        };
        break;
    case GET_ARCHIVED_CLIENT_FULFILLED:
        var invalidEntry = false;
        if(action.payload.data.archivedclients.length > 0) {
            dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.archivedclients[0] : [] ;
        
            if (dataEntry.program === '' || dataEntry.program === null ) {
                dataEntry.program = '1';
            } else {
                dataEntry.program = dataEntry.program.toString();;
            }
            
            if (dataEntry.referraloutcome === '' || dataEntry.referraloutcome === null ) {
                dataEntry.referraloutcome = '1';
            } else {
                dataEntry.referraloutcome = dataEntry.referraloutcome.toString();;
            }
        
            if (dataEntry.clientdischargestatus === '' || dataEntry.clientdischargestatus === null ) {
                dataEntry.clientdischargestatus = '1';
            } else {
                dataEntry.clientdischargestatus = dataEntry.clientdischargestatus.toString();;
            }
        
            if (dataEntry.clientdischargesubstatus === '' || dataEntry.clientdischargesubstatus === null ) {
                dataEntry.clientdischargesubstatus = '1';
            } else {
                dataEntry.clientdischargesubstatus = dataEntry.clientdischargesubstatus.toString();;
            }
        } else {
            dataEntry = {};
            invalidEntry = true;
        }
        state = {
            ...state
            , loadingList: false
            , errorInvalidEntry: invalidEntry
            , dataEntry: dataEntry
            , archivedclients: []
        };
        break;        
    case GET_ARCHIVED_CLIENT_REJECTED:
    case GET_ARCHIVED_CLIENTS_LIST_REJECTED:
    case GET_ARCHIVED_CLIENTS_COUNT_REJECTED:
        state = {
            ...state
            , errors: [action.payload.response]
        };
        break;
    default:
        return state;
  }
  return state;
};
export default reducerArchivedClients;